<template>
  <div v-loading="loading">
    <div class="table-header">
      <div class="title">百科建设</div>
      <el-link
        style="margin-bottom:20px"
        size="small"
        icon="el-icon-question"
        type="primary"
        :underline="false"
        @click="openWay"
        >写作规范</el-link
      >
    </div>
    <el-table :data="tableList" :stripe="true">
      <el-table-column width="110" label="技能点" prop="stack.name">
      </el-table-column>
      <!-- <el-table-column width="110" label="负责人"> </el-table-column> -->
      <el-table-column label="基础信息">-</el-table-column>
      <el-table-column label="知识树">-</el-table-column>
      <el-table-column
        label="极客百科"
        prop="knowledge_contents_count"
      ></el-table-column>
      <el-table-column width="150" label="任务截止时间">
        <template slot-scope="scope">
          <div v-if="scope.row.deadline_date">
            <i class="el-icon-time"></i>
            <span style="margin-left: 10px">{{ scope.row.deadline_date }}</span>
          </div>
          <div v-else>-</div>
        </template>
      </el-table-column>
      <el-table-column width="100">
        <template slot="header">
          <div @click="toggleShowContent" class="toggle-show">
            <span>预估价格</span>
            <i class="el-icon-view toggle-show-icon"></i>
          </div>
        </template>
        <template slot-scope="scope">
          <show-hide-content
            :value="scope.row.price"
            :show.sync="isShow"
          ></show-hide-content>
        </template>
      </el-table-column>
      <el-table-column width="70" label="操作">
        <template slot-scope="scope">
          <el-link
            type="primary"
            :underline="false"
            @click="handleToAdd(scope.row)"
            >去建设</el-link
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="total, prev, pager, next, jumper"
      @current-change="goPage"
      :current-page.sync="pagination.currentPage"
      :page-size="pagination.pageSize"
      :total="pagination.total"
      :hide-on-single-page="true"
    >
    </el-pagination>
  </div>
</template>

<script>
import { mapState } from "vuex";
import skillService from "@/global/service/skill";
import ShowHideContent from "@/components/ShowHideContent";

export default {
  components: {
    ShowHideContent
  },
  watch: {
    $route() {
      this.getData();
    }
  },
  data() {
    return {
      loading: false,
      isShow: false,
      skill_points: [],
      tableList: [],
      examList: [],
      pagination: {
        currentPage: 1,
        pageSize: 20,
        total: 0
      }
    };
  },
  computed: {
    ...mapState(["authPermissions"])
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.loading = true;
      const page = Number(this.$route.query.page) || 1;
      const params = {
        page,
        page_size: this.pagination.pageSize
      };
      skillService
        .skillBuildTasksList(params)
        .then(res => {
          this.tableList = res.list;
          this.pagination.currentPage = Number(res.pagination.current_page);
          this.pagination.total = Number(res.pagination.total);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    goPage(val) {
      this.$router.push({
        name: "SkillWikiList",
        query: { page: val }
      });
    },
    openWay() {
      window.open(
        "https://jiker.feishu.cn/wiki/wikcnnMaVBSexWxXehMmBnKPX2c?open_in_browser=true"
      );
    },
    toggleShowContent() {
      this.isShow = !this.isShow;
    },
    handleToAdd(data) {
      const id = data.id;
      this.$router.push({
        name: "SkillWikiCreateSelf",
        params: {
          id
        }
      });
    }
  }
};
</script>

<style lang="less">
.skill-task-dialog {
  .el-dialog__header,
  .el-dialog__body {
    padding: 0;
  }
}
</style>
<style lang="less" scoped>
.search-box {
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
}
.hidden-redundant {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  &:hover {
    color: #409eff;
  }
}
.toggle-show {
  cursor: pointer;
  .toggle-show-icon {
    margin-left: 4px;
  }
  &:hover {
    color: #409eff;
  }
}
.table-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
